const dataDishes = [
  {
    id: 1,
    price: 25,
    img: "pasta",
    name: "Pasta",
    category: "ITALIAN",
  },

  {
    id: 2,
    price: 50,
    img: "shrimp",
    name: "Shrimp",
    category: "SEAFOOD",
  },

  {
    id: 3,
    price: 30,
    img: "salmon",
    name: "Salmon",
    category: "SEAFOOD",
  },

  {
    id: 4,
    price: 40,
    img: "baked-salmon",
    name: "Baked Salmon",
    category: "SEAFOOD",
  },

  {
    id: 5,
    price: 15,
    img: "cheese-balls",
    name: "Cheese balls",
    category: "APPETIZERS",
  },

  {
    id: 6,
    price: 20,
    img: "easy-pasta",
    name: "Easy Pasta",
    category: "ITALIAN",
  },

  {
    id: 7,
    price: 25,
    img: "spag-tomato",
    name: "Spaghetti",
    category: "ITALIAN",
  },

  {
    id: 8,
    price: 20,
    img: "mixed-pizza",
    name: "Pizza",
    category: "ITALIAN",
  },

  {
    id: 9,
    price: 20,
    img: "spring-rolls",
    name: "Spring Rolls",
    category: "APPETIZERS",
  },

  {
    id: 10,
    price: 15,
    img: "tomato-salad",
    name: "Tomato Salad",
    category: "SALADS",
  },

  {
    id: 11,
    price: 15,
    img: "feta",
    name: "Feta Salad",
    category: "SALADS",
  },
];

export default dataDishes;
